import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, ILayoutSettingsComp, ISocialLinks} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  @Input() footer: ILayoutSettingsComp;
  @Input() logo: string;
  @Input() layoutSetting: ILayoutSettings;
  @Input() linksSocial: ISocialLinks = {
    FacebookUrl: '#',
    InstagramUrl: '#',
    TwitterUrl: '#',
    YouTubeUrl: '#',
  };
  storeUrl = '';
  currentYear: number;
  viewOnly = true;
  constructor( private activatedRoute: ActivatedRoute) {
    this.activatedRoute.data.subscribe(data => {
      this.viewOnly = data.viewOnly != undefined ? data.viewOnly : true;
    });
    this.activatedRoute.params.subscribe(params => {
      if (params['storename']) {
        this.storeUrl = params['storename'];
      }
    });
  }
  isStoreAdmin = localStorage.getItem('role') == "StoreAdmin" ||  localStorage.getItem('role') === 'StoreOwner' ||  localStorage.getItem('role') === 'StoreStaffMember';
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

  displaySocialLink() {
    let display = false;
    if (this.linksSocial) {
      Object.keys(this.linksSocial).forEach((x) => {
        // @ts-ignore
        if (this.linksSocial[x] !== '') {
          display = true;
        }
      });
    }
    return display;
  }

}
